import React, { useState } from 'react';
import { LogOut, UserCheck } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { reloadAfterImpersonationEnd } from './impersonationNav';

/**
 * Barre fixe affichée lorsqu'un admin est connecté en tant qu'un autre utilisateur.
 * Permet de quitter l'impersonation et de revenir au compte admin d'origine.
 */
export default function ImpersonationBanner() {
  const { impersonation, currentUser, endImpersonation } = useAuth();
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  if (!impersonation?.active) return null;

  const handleEnd = async () => {
    setErr('');
    setBusy(true);
    try {
      await endImpersonation();
      // Rechargement dur : purge toute donnée de l'utilisateur impersonné encore en mémoire.
      reloadAfterImpersonationEnd();
    } catch (e) {
      console.error('endImpersonation error:', e);
      setErr("Échec de la sortie d'impersonation. Réessayez ou déconnectez-vous.");
      setBusy(false);
    }
  };

  const who = currentUser?.email || currentUser?.displayName || currentUser?.uid || '';

  return (
    <div className="sticky top-0 z-[1000] w-full bg-amber-500 text-amber-950 shadow-md">
      <div className="max-w-6xl mx-auto px-4 py-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-sm">
        <UserCheck className="w-4 h-4 shrink-0" />
        <span className="font-semibold">Mode impersonation</span>
        <span className="opacity-90 break-all">
          Vous êtes connecté en tant que <strong>{who}</strong>
        </span>
        <div className="flex-1" />
        {err ? <span className="text-red-900 text-xs">{err}</span> : null}
        <button
          type="button"
          onClick={handleEnd}
          disabled={busy}
          className="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg bg-amber-950 text-amber-50 hover:bg-black disabled:opacity-60"
        >
          <LogOut className="w-4 h-4" />
          <span className="text-xs font-semibold">
            {busy ? 'Sortie…' : "Quitter l'impersonation"}
          </span>
        </button>
      </div>
    </div>
  );
}
